import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export type ComplementaryLawModel = {
  id: number;
  item: string;
  description: string;
};

export interface ComplementaryLawSearch {
  search: (query: string) => Promise<ComplementaryLawModel[]>;
}

export class RemoteComplementaryLaw implements ComplementaryLawSearch {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async search(query: string): Promise<ComplementaryLawModel[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: { query },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }
}
